/* eslint-disable react/prop-types */

import React, { useContext } from 'react';
import { Context } from '~context/MainProvider.js';
import Admin from '~atoms/admin/bar';
import styles from './navigation.module.scss';
import { getExtraField, imagePrettyUrl } from '~helpers/getters';

const Navigation = ({
  pageContext,
  logo = '../../../../../images/logo.svg',
  logoWidth = 218,
  logoHeight = 40,
}) => {
  const { admin } = useContext(Context) || {};

  const customLogo = getExtraField(pageContext.page.extra_fields, 'main_logo');

  return (
    <>
      {admin && <Admin page={pageContext.page} marketSections={pageContext.marketSections} />}
      <nav className={styles.nav}>
        <div className={styles.navContainer}>
          <a href="/" className={styles.navLogo}>
            <img
              alt={`${process.env.GATSBY_SITE_NAME} logo`}
              src={customLogo ? imagePrettyUrl(customLogo, logoWidth, logoHeight) : logo}
              width={logoWidth}
              height={logoHeight}
            />
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
